module.exports = __webpack_public_path__ + "static/img/bca_mobile.c7dc243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/bca_mobile.png
// module id = 5dQz
// module chunks = 1